module.exports = __webpack_public_path__ + "static/media/153.4c810ee7.jpg";